var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../service/api.service';
import { ContentBaseService } from '../../../../component/base/contentbase.service';
import { ColumnService } from '../../../../items/columns/column/column.service';
import { KtsTaskService, Task } from './task.service';
import { ConstructionTask, KtsConstructionTaskService } from './construction-task.service';
import { ItemBase } from '../../../../models/item/item-base';
var KtsGeneralTaskService = /** @class */ (function (_super) {
    __extends(KtsGeneralTaskService, _super);
    function KtsGeneralTaskService(logger, api, colservice, taskService, constTaskService) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.colservice = colservice;
        _this.taskService = taskService;
        _this.constTaskService = constTaskService;
        _this.classSeq = [];
        return _this;
    }
    KtsGeneralTaskService.prototype.checkItem = function (rec) {
        var items = rec['items'] || [];
        var check = true;
        checkItemLoop: for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (item.task_m.$type === "delete" /* Delete */) {
                continue;
            }
            if (!this.colservice.checkVal(item.task_m.name) || !this.colservice.checkVal(item.task_u.construction_middle_classification_id)) {
                check = false;
            }
            else if (item.task_u.construction_report && item.task_u.construction_report.length > 0) {
                for (var _a = 0, _b = item.task_u.construction_report; _a < _b.length; _a++) {
                    var report = _b[_a];
                    if (!this.colservice.checkVal(report.visiting_scheduled_date) || !this.colservice.checkVal(report.leaving_scheduled_date) || !this.constTaskService.checkReportStatus(report)) {
                        check = false;
                        break checkItemLoop;
                    }
                }
            }
            else if (item.construction_documents && item.construction_documents.length > 0) {
                for (var _c = 0, _d = item.construction_documents; _c < _d.length; _c++) {
                    var documents = _d[_c];
                    if (documents['$type'] === "delete" /* Delete */) {
                        continue;
                    }
                    if (!this.colservice.checkItemVal(Object.assign(new ItemBase(), { controlType: 'file' }), documents.file)) {
                        check = false;
                        break checkItemLoop;
                    }
                }
            }
        }
        if (this.classSeq.length > 0) {
            check = false;
        }
        if (!check) {
            this.colservice.addError(this.constTaskService.getVisitComp());
        }
        return check;
    };
    KtsGeneralTaskService.prototype.resetClassSeq = function () {
        this.classSeq = [];
    };
    KtsGeneralTaskService.prototype.setClassSeq = function (seq) {
        this.classSeq.push(seq);
    };
    KtsGeneralTaskService.prototype.getClassSeq = function () {
        return this.classSeq;
    };
    KtsGeneralTaskService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsGeneralTaskService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnService },
        { type: KtsTaskService },
        { type: KtsConstructionTaskService }
    ]; };
    return KtsGeneralTaskService;
}(ContentBaseService));
export { KtsGeneralTaskService };
var classData = /** @class */ (function () {
    function classData() {
        this.construction_classification_id = '';
        this.construction_middle_classification_id = '';
        this.task = [];
    }
    return classData;
}());
export { classData };
var TaskData = /** @class */ (function () {
    function TaskData() {
        this.task_m = new Task();
        this.task_u = new ConstructionTask();
        this.construction_documents = [];
        this.construction_documents_delete = [];
        this.task_other_field_m = [];
    }
    return TaskData;
}());
export { TaskData };
var RequestData = /** @class */ (function () {
    function RequestData() {
    }
    return RequestData;
}());
export { RequestData };
var RequestFieldData = /** @class */ (function () {
    function RequestFieldData() {
    }
    return RequestFieldData;
}());
export { RequestFieldData };
var Template = /** @class */ (function () {
    function Template() {
        this.cols = [];
        this.necessity = false;
        this.datetime = false;
        this.date = false;
        this.upload = false;
    }
    return Template;
}());
var TaskTemplate = /** @class */ (function () {
    function TaskTemplate(msg, readonly, mode, fileOptions) {
        this.file = new Template();
        this.confirm = new Template();
        this.standard = new Template();
        this.onsite = new Template();
        this.onsite_notime = new Template();
        this.construction = new Template();
        this.estimate = new Template();
        this.order = new Template();
        this.completion = new Template();
        this.inspection = new Template();
        this.datetime = [];
        this.date = [];
        this.name = {};
        this.necessity = {};
        this.upload = [];
        this.uploadConfirm = {};
        this.multiUpload = [];
        this.field = [];
        var width100per = { formClass: { width: '100per' } };
        var note2 = msg['au.COMPONENTS.label.task_note'];
        var colPlanDate = {
            controlType: 'date',
            label: msg['au.COMPONENTS.label.task_plan_date'],
            key: 'plan_date',
            readonly: (mode === "setting" /* setting */ ? readonly : true)
        };
        var colActDate = {
            controlType: 'date',
            label: msg['au.COMPONENTS.label.task_act_date'],
            key: 'act_date',
            readonly: true
        };
        var confirm = {
            controlType: 'select',
            label: msg['au.COMPONENTS.label.task_is_ok'],
            key: 'is_ok',
            readonly: readonly,
            params: {
                options: [
                    { code: 'true', display: msg['au.COMPONENTS.select.task_ok'] },
                    { code: 'false', display: msg['au.COMPONENTS.select.task_ng'] }
                ]
            }
        };
        this.name = {
            label: msg['au.COMPONENTS.label.task_name'],
            key: 'name',
            controlType: 'text',
            readonly: (mode === "setting" /* setting */ ? readonly : true),
            required: true,
            params: width100per
        };
        this.necessity = {
            controlType: 'select',
            label: msg['au.COMPONENTS.label.task_necessity'],
            key: 'necessity',
            readonly: (mode === "setting" /* setting */ ? readonly : true),
            required: true,
            params: {
                options: [
                    { code: 'true', display: msg['au.COMPONENTS.select.task_necessary'] },
                    { code: 'false', display: msg['au.COMPONENTS.select.task_unnecessary'] }
                ]
            }
        };
        this.datetime = [{
                label: msg['au.COMPONENTS.label.task_datetime'],
                key: 'construction_report',
                readonly: (mode === "setting" /* setting */ ? readonly : true),
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        controlType: 'select',
                        label: msg['au.COMPONENTS.label.task_report_status'],
                        key: 'status',
                        readonly: readonly,
                        params: {
                            options: []
                        }
                    }, {
                        label: msg['au.COMPONENTS.label.task_plan_datetime'],
                        required: true,
                        items: [{
                                controlType: 'datetime',
                                key: 'visiting_scheduled_date',
                                readonly: (mode === "setting" /* setting */ ? readonly : true),
                                hidden: ((mode === "progress" /* progress */ || readonly) ? true : false),
                                params: {
                                    range: { from: 'visiting_scheduled_date', to: 'leaving_scheduled_date' }
                                }
                            }, {
                                label: '~',
                                controlType: 'label'
                            }, {
                                controlType: 'datetime',
                                key: 'leaving_scheduled_date',
                                readonly: (mode === "setting" /* setting */ ? readonly : true),
                                hidden: ((mode === "progress" /* progress */ || readonly) ? true : false),
                                params: {
                                    range: { from: 'visiting_scheduled_date', to: 'leaving_scheduled_date' }
                                }
                            }]
                    }, {
                        label: msg['au.COMPONENTS.label.task_arrival_datetime'],
                        readonly: readonly,
                        items: [{
                                controlType: 'datetime',
                                key: 'arrival_actual_date'
                            }]
                    }, {
                        label: msg['au.COMPONENTS.label.task_act_datetime'],
                        readonly: readonly,
                        items: [{
                                controlType: 'datetime',
                                key: 'visiting_actual_date',
                                params: {
                                    range: { from: 'visiting_actual_date', to: 'leaving_actual_date' }
                                }
                            }, {
                                label: '~',
                                controlType: 'label'
                            }, {
                                controlType: 'datetime',
                                key: 'leaving_actual_date',
                                params: {
                                    range: { from: 'visiting_actual_date', to: 'leaving_actual_date' }
                                }
                            }]
                    }]
            }];
        this.date = JSOG.parse(JSON.stringify(this.datetime));
        this.date[0].label = msg['au.COMPONENTS.label.task_date'];
        this.date[0].items[2].label = msg['au.COMPONENTS.label.task_plan_date'];
        this.date[0].items[2].items[0].controlType = 'date';
        this.date[0].items[2].items[2].controlType = 'date';
        this.date[0].items[2].items[0].params['formClass'] = { width: '150' };
        this.date[0].items[2].items[2].params['formClass'] = { width: '150' };
        this.upload = [{
                controlType: 'select',
                label: msg['au.COMPONENTS.label.task_file_genre'],
                key: 'documents_genre_id',
                readonly: readonly,
                params: {
                    options: []
                }
            }, {
                controlType: 'text',
                label: msg['au.COMPONENTS.label.task_file_title'],
                key: 'documents_title',
                readonly: readonly
            }, {
                controlType: 'select',
                label: msg['au.COMPONENTS.label.task_referrer_type'],
                key: 'documents_type',
                readonly: readonly,
                required: true,
                params: {
                    options: []
                }
            }];
        this.uploadConfirm = confirm;
        this.multiUpload = [{
                label: msg['au.COMPONENTS.label.task_file'],
                key: 'construction_documents',
                readonly: readonly,
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        controlType: 'file',
                        label: msg['au.COMPONENTS.label.task_file'],
                        key: 'file',
                        readonly: readonly,
                        params: width100per
                    }, {
                        key: 'file_name',
                        hidden: true
                    }]
            }];
        this.field = [{
                label: msg['au.COMPONENTS.label.task_other_field'],
                key: 'task_other_field_m',
                readonly: readonly,
                items: [{
                        key: 'id',
                        hidden: true
                    }, {
                        key: 'value',
                        controlType: 'text',
                        params: width100per
                    }]
            }];
        this.file = Object.assign(new Template(), {
            note1: msg['au.COMPONENTS.label.task_note_file'],
            note2: note2,
            cols: [colPlanDate, colActDate],
            upload: true,
            necessity: true
        });
        this.construction = this.onsite = Object.assign(new Template(), {
            note1: msg['au.COMPONENTS.label.task_note_visit'],
            note2: note2,
            cols: [{
                    controlType: 'select',
                    label: msg['au.COMPONENTS.label.task_partner_company'],
                    key: 'partner_company_m_id',
                    readonly: (mode === "setting" /* setting */ ? readonly : true),
                    params: {
                        options: []
                    }
                }, {
                    controlType: 'select',
                    label: msg['au.COMPONENTS.label.task_secondary_partner_company'],
                    key: 'secondary_partner_company_m_id',
                    readonly: (mode === "setting" /* setting */ ? readonly : true),
                    params: {
                        options: []
                    }
                }, confirm],
            datetime: true,
            necessity: true
        });
        this.onsite_notime = Object.assign({}, this.onsite, { datetime: false, date: true });
        this.confirm = this.inspection = Object.assign(new Template(), {
            note1: msg['au.COMPONENTS.label.task_note_confirm'],
            note2: note2,
            cols: [colPlanDate, colActDate, confirm],
            necessity: true
        });
        this.estimate = this.order = this.completion = Object.assign(new Template(), {
            note1: msg['au.COMPONENTS.label.task_note_material'],
            note2: note2,
            cols: [colPlanDate, colActDate, {
                    label: msg['au.COMPONENTS.label.task_material'],
                    items: [{
                            label: msg['au.COMPONENTS.label.task_material_label'],
                            controlType: 'label'
                        }]
                }]
        });
        this.standard = Object.assign(new Template(), {
            note1: msg['au.COMPONENTS.label.task_note_standard'],
            note2: note2,
            cols: [colPlanDate, Object.assign({}, colActDate, { readonly: readonly })],
            necessity: true
        });
    }
    return TaskTemplate;
}());
export { TaskTemplate };
//# sourceMappingURL=general-task.service.js.map